'use strict';

var React = require('react');
var withStyles = require('../../DesignSystem/Styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    svg: {
      backgroundColor: theme.palette.brandPrimaryLight.main,
      width: "100%",
      height: "100%"
    }
  };
};

var AttachmentImage = function AttachmentImage(_ref) {
  var classes = _ref.classes;
  return React__default["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: classes.svg,
    viewBox: "0 0 174 174"
  }, React__default["default"].createElement("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default["default"].createElement("path", {
    fill: "#000",
    "fill-opacity": ".38",
    d: "M94.5 77v19.167c0 3.683-2.983 6.666-6.667 6.666-3.683 0-6.666-2.983-6.666-6.666V75.333c0-2.3 1.866-4.166 4.166-4.166 2.3 0 4.167 1.866 4.167 4.166v17.5c0 .917-.75 1.667-1.667 1.667-.916 0-1.666-.75-1.666-1.667V77h-2.5v15.833c0 2.3 1.866 4.167 4.166 4.167 2.3 0 4.167-1.867 4.167-4.167v-17.5c0-3.683-2.983-6.666-6.667-6.666-3.683 0-6.666 2.983-6.666 6.666v20.834c0 5.066 4.1 9.166 9.166 9.166 5.067 0 9.167-4.1 9.167-9.166V77h-2.5z"
  })));
};

var AttachmentImage$1 = withStyles["default"](styles)(AttachmentImage);

module.exports = AttachmentImage$1;
